import {SystemEntryProperties,SystemEntryFallback} from "../SystemEntry";
import {SystemFileCallback} from "../SystemFile/useSystemFile";


export const SystemFolderCallback={
    name:"callback",
    type:"(sysfolder:SystemFolder):void",
};

export default {
    name:"SystemFolder",
    type:"object",
    props:[
        ...SystemEntryProperties,
        {
            name:"useFile",
            type:{
                name:"(name:string,callback:function,fallback:function):Promise<SystemFile>",
                hash:"useSystemFile",
            },
            description:"Gets a file from the current folder and creates it if not found",
            props:[SystemFileCallback,SystemEntryFallback],
        },
        {
            name:"useFolder",
            type:"(name:string,callback:function:void,fallback:function):Promise<SystemFolder>",
            description:"Gets a folder from the current folder and creates it if not found",
            props:[SystemFolderCallback,SystemEntryFallback],
        },
        {
            name:"useEntries",
            type:"(callback:function,fallback:function):Promise<SystemFolderEntry[]>",
            props:[
                {
                    name:"callback",
                    type:"(entries:SystemFolderEntry[]):void",
                },
                SystemEntryFallback,
                {
                    name:"SystemFolderEntry",
                    type:"object",
                    props:[
                        {name:"name",type:"string"},
                        {name:"fullpath",type:"string"},
                        {name:"isFile",type:"boolean"},
                        {
                            name:"toSystemFile",
                            type:{
                                name:"(callback:function:void,fallback:function):Promise<SystemFile>",
                                hash:"useSystemFile",
                            },
                            description:"only for file entries",
                            props:[SystemFileCallback,SystemEntryFallback],
                        },
                        {
                            name:"toSystemFolder",
                            type:"(callback:function:void,fallback:function):Promise<SystemFolder>",
                            description:"only for folder entries",
                            props:[SystemFolderCallback,SystemEntryFallback],
                        }
                    ],
                }
            ],
        }
    ],
};
